module.exports = __webpack_public_path__ + "static/assets/e3f32b885decb4f023061cd4e9b317b5.png";